import { render, staticRenderFns } from "./safetyGear.vue?vue&type=template&id=4a8d3c4a"
import script from "./safetyGear.vue?vue&type=script&lang=js"
export * from "./safetyGear.vue?vue&type=script&lang=js"
import style0 from "./safetyGear.vue?vue&type=style&index=0&id=4a8d3c4a&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8d3c4a')) {
      api.createRecord('4a8d3c4a', component.options)
    } else {
      api.reload('4a8d3c4a', component.options)
    }
    module.hot.accept("./safetyGear.vue?vue&type=template&id=4a8d3c4a", function () {
      api.rerender('4a8d3c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGear.vue"
export default component.exports